import React from "react";
import {
  Row,
  Col,
  FormGroup,
  FormControl,
  ControlLabel
} from "react-bootstrap";
import "react-select/dist/react-select.css";

//This is required for CC card rendering on step 3
import 'react-credit-cards/es/styles-compiled.css';

class Step1 extends React.Component {
  constructor(props) {
    super(props);
    this._grabUserInput = this._grabUserInput.bind(this);
    this.state = {
      //newexistingRadio:props.getStore().newexistingRadio,
      firstname: props.getStore().firstname,
      lastname: props.getStore().lastname,
      company: props.getStore().company,
      address: props.getStore().address,
      city: props.getStore().city,
      state: props.getStore().state,
      zip: props.getStore().zip,
      country: props.getStore().country,
      email: props.getStore().email,
      phone: props.getStore().phone,
      firstnameError: null,
      lastnameError: null,
      companyError: null,
      addressError: null,
      cityError: null,
      stateError: null,
      zipError: null,
      countryError: null,
      emailError: null,
      phoneError: null,
      //newexistingError: null,
    };
  }


  isValidated() {
    const userInput = this._grabUserInput(); // grab user entered vals
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    re.test(this.state.email) === false
      ? this.setState({
          emailError: (
            <small className="text-danger">
              Email is required and format should be <i>john@doe.com</i>.
            </small>
          )
        })
      : this.setState({ emailError: null });
    //check each required field for validation
      this.state.firstname === ""
          ? this.setState({
              firstnameError: (
                  <small className="text-danger">
                      Please provide your first name.
                  </small>
              )
          })
          : this.setState({ firstnameError: null });
      var fn = this.state.firstname !== "";

      this.state.lastname === ""
          ? this.setState({
              lastnameError: (
                  <small className="text-danger">
                      Please provide your last name.
                  </small>
              )
          })
          : this.setState({ lastnameError: null });
      var ln = this.state.lastname !== "";

      this.state.company === ""
          ? this.setState({
              companyError: (
                  <small className="text-danger">
                      Please provide your Company Name.
                  </small>
              )
          })
          : this.setState({ companyError: null });
      var company = this.state.company !== "";

      this.state.address === ""
          ? this.setState({
              addressError: (
                  <small className="text-danger">
                      Please provide your current address.
                  </small>
              )
          })
          : this.setState({ addressError: null });
      var ad = this.state.address !== "";

      this.state.city === ""
          ? this.setState({
              cityError: (
                  <small className="text-danger">
                      Please provide your city.
                  </small>
              )
          })
          : this.setState({ cityError: null });
      var ct = this.state.city !== "";

      this.state.state === ""
          ? this.setState({
              stateError: (
                  <small className="text-danger">
                      Please provide your state.
                  </small>
              )
          })
          : this.setState({ stateError: null });
      var st = this.state.state !== "";

      this.state.zip === ""
          ? this.setState({
              zipError: (
                  <small className="text-danger">
                      Please provide your zip code.
                  </small>
              )
          })
          : this.setState({ zipError: null });
      var zp = this.state.zip !== "";

      this.state.country === ""
          ? this.setState({
              countryError: (
                  <small className="text-danger">
                      Please provide your Country.
                  </small>
              )
          })
          : this.setState({ countryError: null });
      var country = this.state.country !== "";

      this.state.phone === ""
          ? this.setState({
              phoneError: (
                  <small className="text-danger">
                      Please provide a contact phone number.
                  </small>
              )
          })
          : this.setState({ phoneError: null });
      var ph = this.state.phone !== "";

      var valid = (fn && ln && company && ad && ct && st && zp && country && ph && re.test(this.state.email));
      if(valid)
          this.props.updateStore({
              ...userInput,
              sentEmail: false // use this to notify step4 that some changes took place and prompt the user to save again
          });
    return valid;
  }
  _grabUserInput() {

    return {
        //newexisting: this.state.newexisting.value, //Special shit because select component blows arse
        //newexistingRadio: this.state.newexistingRadio,
        firstname: document.getElementById('fname').value,
        lastname: document.getElementById('lname').value,
        company: document.getElementById('company').value,
        address: document.getElementById('address').value,
        city: document.getElementById('city').value,
        state: document.getElementById('state').value,
        zip: document.getElementById('zip').value,
        country: document.getElementById('country').value,
        email: document.getElementById('email').value,
        phone: document.getElementById('phone').value
    };
  }

    handleRadio = event => {
        const target = event.target;
        this.setState({
            [target.name]: target.value
        });
    };

  render() {
    return (
      <div className="wizard-step">
          <Row>
              {/*
              <Col md={5} mdOffset={1}>
              <hr style={{ margin: '30px 0' }} />
              <SupportedCards />
              </Col>
              <Col md={5} mdOffset={1}>
                  <Elements>
                  <CardElement style={{base: {fontSize: '18px'}}} />
                  </Elements>
              </Col>
              */}
          </Row>
          {/*
          <Row>
              <Col md={5} mdOffset={1}>
                  <FormGroup>
                      <ControlLabel>Are you a New or Existing Customer? <span className="text-danger">*</span> </ControlLabel>
                      <Radio
                          number="1dr"
                          option="1"
                          name="newexistingRadio"
                          onChange={this.handleRadio}
                          checked={this.state.newexistingRadio === "1"}
                          label="New"
                      />
                      <Radio
                          number="2dr"
                          option="2"
                          name="newexistingRadio"
                          onChange={this.handleRadio}
                          checked={this.state.newexistingRadio === "2"}
                          label="Existing"
                      />
                  </FormGroup>
              </Col>
          </Row>
          */}
        <Row>
          <Col md={5} mdOffset={1}>
            <FormGroup>
              <ControlLabel>First Name <span className="text-danger">*</span></ControlLabel>
                {(this.state.firstnameError === null) ? (
                  <FormControl
                    className="valid"
                    id="fname"
                    type="text"
                    defaultValue={this.state.firstname}
                    name="first_name"
                    placeholder="ex: Mike"
                    value={this.state.firstname}
                    onChange={event => this.setState({ firstname: event.target.value })}
                  />
                    ) : (
                    <FormControl
                        className="error"
                        id="fname"
                        type="text"
                        defaultValue={this.state.firstname}
                        name="first_name"
                        placeholder="ex: Mike"
                        value={this.state.firstname}
                        onChange={event => this.setState({ firstname: event.target.value })}
                    />
                )}
                {this.state.firstnameError}
            </FormGroup>
          </Col>
          <Col md={5}>
            <FormGroup>
              <ControlLabel>Last Name <span className="text-danger">*</span></ControlLabel>
                {(this.state.lastnameError === null) ? (
                      <FormControl
                        className="valid"
                        id="lname"
                        type="text"
                        name="last_name"
                        defaultValue={this.state.lastname}
                        placeholder="ex: Andrew"
                        value={this.state.lastname}
                        onChange={event => this.setState({ lastname: event.target.value })}
                      />
                    ) : (
                    <FormControl
                        className="error"
                        id="lname"
                        type="text"
                        name="last_name"
                        defaultValue={this.state.lastname}
                        placeholder="ex: Andrew"
                        value={this.state.lastname}
                        onChange={event => this.setState({ lastname: event.target.value })}
                    />
                )}
                {this.state.lastnameError}
            </FormGroup>
          </Col>
        </Row>
          <Row>
              <Col md={5}  mdOffset={1}>
                  <FormGroup>
                      <ControlLabel>Company <span className="text-danger">*</span></ControlLabel>
                      {(this.state.companyError === null) ? (
                          <FormControl
                              className="valid"
                              id="company"
                              type="text"
                              name="company"
                              defaultValue={this.state.company}
                              placeholder="ex: My Cool Company Name"
                              value={this.state.company}
                              onChange={event => this.setState({ company: event.target.value })}
                          />
                          ) : (
                          <FormControl
                              className="error"
                              id="company"
                              type="text"
                              name="company"
                              defaultValue={this.state.company}
                              placeholder="ex: My Cool Company Name"
                              value={this.state.company}
                              onChange={event => this.setState({ company: event.target.value })}
                          />
                      )}
                      {this.state.companyError}
                  </FormGroup>
              </Col>
              <Col md={5}>
                  <FormGroup>
                      <ControlLabel>Address <span className="text-danger">*</span></ControlLabel>
                      {(this.state.addressError === null) ? (
                          <FormControl
                              className="valid"
                              id="address"
                              type="text"
                              defaultValue={this.state.address}
                              name="address"
                              placeholder="ex: 8675 County Road 309"
                              value={this.state.address}
                              onChange={event => this.setState({ address: event.target.value })}
                          />
                          ) : (
                          <FormControl
                              className="error"
                              id="address"
                              type="text"
                              defaultValue={this.state.address}
                              name="address"
                              placeholder="ex: 8675 County Road 309"
                              value={this.state.address}
                              onChange={event => this.setState({ address: event.target.value })}
                          />

                      )}
                      {this.state.addressError}
                  </FormGroup>
              </Col>
          </Row>
          <Row>
              <Col md={3} mdOffset={1}>
                  <FormGroup>
                      <ControlLabel>City <span className="text-danger">*</span></ControlLabel>
                      {(this.state.cityError === null) ? (
                          <FormControl
                              className="valid"
                              id="city"
                              type="text"
                              defaultValue={this.state.city}
                              name="city"
                              placeholder="ex: Elizabeth"
                              value={this.state.city}
                              onChange={event => this.setState({ city: event.target.value })}
                          />
                          ) : (
                          <FormControl
                              className="error"
                              id="city"
                              type="text"
                              defaultValue={this.state.city}
                              name="city"
                              placeholder="ex: Elizabeth"
                              value={this.state.city}
                              onChange={event => this.setState({ city: event.target.value })}
                          />
                      )}
                      {this.state.cityError}
                  </FormGroup>
              </Col>
              <Col md={3}>
                  <FormGroup>
                      <ControlLabel>State <span className="text-danger">*</span></ControlLabel>
                      {(this.state.stateError === null) ? (
                          <FormControl
                              className="valid"
                              id="state"
                              type="text"
                              name="state"
                              defaultValue={this.state.state}
                              placeholder="ex: Colorado"
                              value={this.state.state}
                              onChange={event => this.setState({ state: event.target.value })}
                          />
                          ) : (
                          <FormControl
                              className="error"
                              id="state"
                              type="text"
                              name="state"
                              defaultValue={this.state.state}
                              placeholder="ex: Colorado"
                              value={this.state.state}
                              onChange={event => this.setState({ state: event.target.value })}
                          />
                      )}
                      {this.state.stateError}
                  </FormGroup>
              </Col>
              <Col md={4}>
                  <FormGroup>
                      <ControlLabel>Zip <span className="text-danger">*</span></ControlLabel>
                      {(this.state.zipError === null) ? (
                          <FormControl
                              className="valid"
                              id="zip"
                              type="text"
                              name="zip"
                              defaultValue={this.state.zip}
                              placeholder="ex: 80107"
                              value={this.state.zip}
                              onChange={event => this.setState({ zip: event.target.value })}
                          />
                          ) : (
                          <FormControl
                              className="error"
                              id="zip"
                              type="text"
                              name="zip"
                              defaultValue={this.state.zip}
                              placeholder="ex: 80107"
                              value={this.state.zip}
                              onChange={event => this.setState({ zip: event.target.value })}
                          />
                      )}
                      {this.state.zipError}
                  </FormGroup>
              </Col>
          </Row>
          <Row>
              <Col md={3} mdOffset={1}>
                  <FormGroup>
                      <ControlLabel>Country <span className="text-danger">*</span></ControlLabel>
                      {(this.state.countryError === null) ? (
                          <FormControl
                              className="valid"
                              id="country"
                              type="text"
                              defaultValue={this.state.country}
                              name="country"
                              placeholder="ex: USA"
                              value={this.state.country}
                              onChange={event => this.setState({ country: event.target.value })}
                          />
                      ) : (
                          <FormControl
                              className="error"
                              id="country"
                              type="text"
                              defaultValue={this.state.country}
                              name="country"
                              placeholder="ex: USA"
                              value={this.state.country}
                              onChange={event => this.setState({ country: event.target.value })}
                          />
                      )}
                      {this.state.countryError}
                  </FormGroup>
              </Col>

          <Col md={3}>
              <FormGroup>
                  <ControlLabel>
                      Email <span className="text-danger">*</span>
                  </ControlLabel>
                  {(this.state.emailError === null) ? (
                  <FormControl
                      className="valid"
                      id="email"
                      type="email"
                      name="email"
                      value={this.state.email}
                      placeholder="ex: dd@disney.com"
                      onChange={event => this.setState({ email: event.target.value })}
                  />
                  ) : (
                  <FormControl
                      className="error"
                      id="email"
                      type="email"
                      name="email"
                      value={this.state.email}
                      placeholder="ex: dd@disney.com"
                      onChange={event => this.setState({ email: event.target.value })}
                  />
                  )}
                  {this.state.emailError}
              </FormGroup>
          </Col>
            <Col md={4}>
                <FormGroup>
                    <ControlLabel>
                        Phone <span className="text-danger">*</span>
                    </ControlLabel>
                    {(this.state.phoneError === null) ? (
                        < FormControl
                        className="valid"
                        id="phone"
                        type="tel"
                        pattern="^\d{3}-\d{3}-\d{4}$"
                        name="phone"
                        value={this.state.phone}
                        placeholder="ex: (303) 867-5309"
                        onChange={event => this.setState({phone: event.target.value})}
                        />
                    ) : (
                        <FormControl
                        className="error"
                        id="phone"
                        type="tel"
                        pattern="^\d{3}-\d{3}-\d{4}$"
                        name="phone"
                        value={this.state.phone}
                        placeholder="ex: (303) 867-5309"
                        onChange={event => this.setState({phone: event.target.value})}
                        />
                    )}
                    {this.state.phoneError}
                </FormGroup>
            </Col>
      </Row>
      </div>
    );
  }
}

export default Step1;



// WEBPACK FOOTER //
// ./src/views/Forms/RegisterWizard/Step1.jsx